import CalendarComponent from 'components/Input/Calendar';
import NumberComponent from 'components/Input/NumberComponent';
import NumberStringComponent from 'components/Input/NumberStringComponent';
import ZipCodeComponent from 'components/Input/ZipCodeComponent';
import { Form } from 'react-bootstrap';
import 'assets/css/textcomponent.css';

function getStyle(props) {
  return {
    ...props.style,
    background: props.error ? 'lightpink' : props.disabled ? '#eeeeee' : undefined,
    color: props.color ? props.color : props.disabled ? '#444444' : undefined,
  };
}

// テキストコンポーネント
function TextComponent(props) {
  switch (props.type) {
    // 日付
    case 'date':
      return (
        // 入力不可の場合は通常のテキスト
        props.disabled ? (
          <Form.Control
            type="text"
            value={props.value}
            disabled={props.disabled}
            style={getStyle(props)}
          />
        ) : (
          <CalendarComponent
            value={props.value}
            onChange={props.onChange}
            disabled={props.disabled}
            selectionMode={props.selectionMode}
            error={props.error}
          />
        )
      );
    // テキストエリア
    case 'textarea':
      return (
        <Form.Control
          as={props.type}
          rows={props.rows}
          value={props.value}
          disabled={props.disabled}
          readOnly={props.readOnly}
          maxLength={props.maxLength}
          placeholder={props.placeholder}
          onChange={(e) => (props.onChange ? props.onChange(e.target) : null)}
          style={getStyle(props)}
        ></Form.Control>
      );
    // 数値
    case 'number':
      return (
        <NumberComponent
          className={props.className}
          fmt={props.fmt}
          value={props.value}
          disabled={props.disabled}
          onChange={props.onChange}
          max={props.max}
        ></NumberComponent>
      );
    // 文字列型数値
    case 'numberString':
      return (
        <NumberStringComponent
          value={props.value}
          className={props.className}
          onChange={props.onChange}
          onBlur={(e) => (props.onBlur ? props.onBlur(e.target) : null)}
          disabled={props.disabled}
          maxLength={props.maxLength}
          style={getStyle(props)}
        />
      );
    // 郵便番号
    case 'zipcode':
      return (
        <ZipCodeComponent
          className={props.className}
          value={props.value}
          disabled={props.disabled}
          maxLength={7}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          onPaste={props.onPaste}
          style={getStyle(props)}
          error={props.error}
        />
      );
    // テキスト
    case 'text':
    default:
      return (
        <Form.Control
          className={props.className}
          placeholder={props.placeholder}
          type={props.type}
          value={props.value}
          disabled={props.disabled}
          onChange={(e) => (props.onChange ? props.onChange(e.target) : null)}
          onBlur={(e) => (props.onBlur ? props.onBlur(e.target) : null)}
          maxLength={props.maxLength}
          style={getStyle(props)}
        ></Form.Control>
      );
  }
}

export default TextComponent;
